import { isIpadApp } from '@src/slide/infrastructure/module/dependent/config/tob/enterprise-config';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import BaseShortcutActions from '../base/actions';
import MobileToolbarDataProcessor from '@src/framework/frame-m/components/tool-bar-m/menu/toolbar-data-processor';
import { preventDefault, stopPropagation } from '../decorator';
import { IMobileShortcutActionsServices, IMobileActionsInjectable } from '../interface';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';

export default class MobileShortcutActions extends BaseShortcutActions {
    protected services: IMobileShortcutActionsServices;
    protected injectable?: IMobileActionsInjectable;
    public constructor(
        services: Partial<IMobileShortcutActionsServices>,
        injectable?: IMobileActionsInjectable,
    ) {
        super(services);
        this.services = services;
        this.injectable = injectable;
        // 这里初始化ipad客户端系统键盘undo redo与native端接口
        this.initUndoRedoNativeCall();
    }
    /* 注释迁移
     * 以下几项理应是触发工具栏或者菜单栏的方法，但是目前两端均没有提供直接触发的方法和能力
     * 而这里通过快捷键处理的时候并不能拿到当前的状态，因此不能通过两端的方式直接触发回调方法
     * 因此使用比较hack的方式，之后工具栏提供对外方法了以后再通过类似的action方式触发
     */
    @stopPropagation
    @preventDefault
    public italic() {
        if (isIpadApp()) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.M_EDIT_FORMAT,
                action: TDWActionType.M_EDIT_ITALIC,
            });
            const retCallback = this.menuManager?.stylePanelMenu();
            retCallback?.callback?.(MenuType.TOOLBAR, 'italic', !this.getMobileToolbarManagerValue('italic'));
        }
    }

    @stopPropagation
    @preventDefault
    public bold() {
        if (isIpadApp()) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.M_EDIT_FORMAT,
                action: TDWActionType.M_EDIT_ITALIC,
            });
            const retCallback = this.menuManager?.stylePanelMenu();
            retCallback?.callback?.(MenuType.TOOLBAR, 'bold', !this.getMobileToolbarManagerValue('bold'));
        }
    }

    @stopPropagation
    @preventDefault
    public underline() {
        if (isIpadApp()) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.M_EDIT_FORMAT,
                action: TDWActionType.M_EDIT_ITALIC,
            });
            const retCallback = this.menuManager?.stylePanelMenu();
            retCallback?.callback?.(MenuType.TOOLBAR, 'underLine', !this.getMobileToolbarManagerValue('underLine'));
        }
    }

    @stopPropagation
    @preventDefault
    public 'delete-line'() {
        if (isIpadApp()) {
            tdw({
                opername: TDWOperationType.DOC_PPT,
                module: TDWModuleType.M_EDIT_FORMAT,
                action: TDWActionType.M_EDIT_ITALIC,
            });
            const retCallback = this.menuManager?.stylePanelMenu();
            retCallback?.callback?.(MenuType.TOOLBAR, 'deleteLine', !this.getMobileToolbarManagerValue('deleteLine'));
        }
    }

    @stopPropagation
    @preventDefault
    public async undo() {
        if (!this.mobileToolbarDynamicService) {
            return;
        }
        const mobileToolbarService = await this.mobileToolbarDynamicService.promise();
        mobileToolbarService.handleTouchStart(ActionType.UNDO, '');
    }

    @stopPropagation
    @preventDefault
    public async redo() {
        if (!this.mobileToolbarDynamicService) {
            return;
        }
        const mobileToolbarService = await this.mobileToolbarDynamicService.promise();
        mobileToolbarService.handleTouchStart(ActionType.REDO, '');
    }

    private get mobileToolbarDynamicService() {
        return this.services.mobileToolbarDynamicService;
    }


    // ipad 端获取value工具函数
    private getMobileToolbarManagerValue = (type) => {
        let value = null;
        const stylePanelData = MobileToolbarDataProcessor.processData();
        stylePanelData.forEach((item) => {
            if (item.id === type) {
                value = item.value;
            }
        });
        return value;
    };

    // 这个是不是没用了
    private initUndoRedoNativeCall = () => {
        if (!isIpadApp()) return;
        // @ts-ignore
        window.toolbarClick = (name) => {
            if (name === 'undo') {
                this.undo();
            } else if (name === 'redo') {
                this.redo();
            } else {
                window.log.error(`ipad native trigger toolbarClick name argument illegal, require undo/redo, but got ${name}`);
            }
        };
    };
}

export type IMobileShortcutActions = Omit<MobileShortcutActions, 'setServicesDelegates'>;
